import React from 'react'
import { Modal as UiModal } from '../../../ui'

interface modalInterface {
    children: React.ReactNode
    modalState: boolean
    previewModalAction: () => void
    title?: React.ReactNode
    size?: 'sm' | 'md' | 'lg' | 'xl'
}

/**
 * Legacy modal API (`modalState` / `previewModalAction`). New code should use
 * `Modal` from `ui` with `open` / `onClose`.
 */
function Modal({ children, modalState, previewModalAction, title, size = 'md' }: modalInterface) {
    return (
        <UiModal open={modalState} onClose={previewModalAction} title={title} size={size}>
            {children}
        </UiModal>
    )
}

export default Modal
